import { render, staticRenderFns } from "./GroupModal.vue?vue&type=template&id=12d423be&scoped=true"
import script from "./GroupModal.vue?vue&type=script&lang=js"
export * from "./GroupModal.vue?vue&type=script&lang=js"
import style0 from "./GroupModal.vue?vue&type=style&index=0&id=12d423be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d423be",
  null
  
)

export default component.exports